import React from 'react';

import { Alert, Flex, Typography } from 'antd';



export function SignedUpStep() {
    return (
        <Flex vertical gap="middle">
            <Typography.Paragraph style={{ margin: 0, fontWeight: 600 }}>
                Acesso liberado
            </Typography.Paragraph>

            <Alert
                message="Seu acesso por reconhecimento facial está liberado!"
                type="success"
                showIcon
            />

            <Typography.Paragraph style={{ margin: 0 }}>
                Você poderá acessar o condomínio durante o período informado apenas aproximando seu rosto do terminal de acesso.
            </Typography.Paragraph>

            <Typography.Paragraph type="secondary" italic style={{ margin: 0 }}>
                O processo foi concluido com sucesso. Você já pode fechar esta página.
            </Typography.Paragraph>
        </Flex>
    );
}
